import { render, staticRenderFns } from "./AddMyCredential.vue?vue&type=template&id=c635d330&scoped=true&"
import script from "./AddMyCredential.vue?vue&type=script&lang=js&"
export * from "./AddMyCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c635d330",
  null
  
)

export default component.exports